'use strict';

/**
 * library
 */
import 'slick-carousel';

/**
 * tab
 */
export const tab = (() => {
    const $nav = $('.js-nav-tab');
    const $item = $('.js-item-tab');
    let classes = [];

    $nav.find('.nav-tab__item').each(i => {
        if (i > 0) {
            classes += ' nav-tab--' + (i + 1);
        } else {
            classes += 'nav-tab--' + (i + 1);
        }
    });

    const init = () => {
        $nav.on('beforeChange', (e, slick, currentSlide, nextSlide) => {
            $nav.removeClass(classes);
            $nav.addClass('nav-tab--' + (nextSlide + 1));
        });

        $nav.slick({
            speed: 300,
            infinite: false,
            draggable: false,
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            variableWidth: true,
            centerMode: false,
            centerPadding: '0',
            focusOnSelect: true,
            asNavFor: $item[0],
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        infinite: true,
                        draggable: true,
                        centerMode: true,
                        slidesToShow: 1
                    }
                }
            ]
        });

        $item.slick({
            fade: true,
            speed: 200,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
            adaptiveHeight: true,
            centerMode: true,
            centerPadding: '0',
            asNavFor: $nav[0],
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        fade: false,
                        speed: 300,
                        variableWidth: true
                    }
                }
            ]
        });
    };

    return {
        init: init
    };
})();
